import { CartProduct } from 'lib/core/services/gtm/types'
import { getPriceValues } from 'lib/core/resources/helpers'
import { GTM } from 'lib/core/services/gtm'
import { CartObject } from 'lib/core/data/quote/cart/types'
import { useMemo } from 'react'

interface TriggerCheckout {
  cart?: CartObject
  step: string
  description: string
}

interface TriggerProductClick {
  sku: string
  name: string
  listPage: string
}

export const useGTM = () => {
  return useMemo(() => {
    const triggerCheckout = ({ cart, step, description }: TriggerCheckout) => {
      if (cart) {
        const items = cart.data?.items
        const cartProducts: CartProduct[] = []

        items?.forEach(item => {
          const { quantity, product } = item
          const { sku, price, name } = product
          const [amount] = getPriceValues(price)

          cartProducts.push({
            id: sku,
            name: name,
            price: amount.toString(),
            quantity
          })
        })

        if (cartProducts.length) {
          GTM.checkout({
            step: step,
            description: description,
            products: cartProducts
          })
        }
      }
    }

    const triggerProductClick = ({ sku, name, listPage }: TriggerProductClick) => {
      const productGTM = { id: sku, name }
      GTM.productClick({ product: productGTM, list: listPage })
    }

    return {
      triggerCheckout,
      triggerProductClick
    }
  }, [])
}
